<template>
	<div class="button-icon-group">
		<label
			v-for="item in items"
			:key="item.id"
			v-bind:class="['button-icon-group__item', item.value === active ? 'active' : '']"
			:data-index="item.value"
		>
			<span class="button-icon-group__icon"></span>
			<input
				type="radio"
				name="options"
				:value="item.value"
				autocomplete="off"
				v-model="active"
				@change="change(active)"
			/>
			<span>{{ item.name }}</span>
		</label>
	</div>
</template>

<script>
export default {
	data() {
		return {
			active: null
		};
	},
	created() {
		this.active = this.def;
	},
	props: {
		items: {
			type: Array,
			default: []
		},
		change: {
			type: Function
		},
		def: {
			type: String,
			default: null
		}
	}
};
</script>
